import axios from "axios";
import helpers from "@/helpers";

export default {
    getWarnings({commit}) {

        axios.get(process.env.VUE_APP_API_URL + `/warning`)
            .then(response => (commit('storeWarnings', response.data.data)))
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    getWarningById({commit}, warningId) {

        axios.get(process.env.VUE_APP_API_URL + `/warning/${warningId}`)
            .then(response => (commit('storeWarning', response.data)))
            .catch(e => {
                helpers.handleMildAxiosError(e)
            })
    },
    storeWarning({commit}, article) {

        axios.put(process.env.VUE_APP_API_URL + `/warning/${article.id}`, article)
            .then(() => {
                helpers.handleSuccessMessage("Der Hinweis wurde gespeichert.", "Gespeichert")
            })
        commit('none')
    },
    createWarning({commit}, warning) {
        return axios.post(process.env.VUE_APP_API_URL + `/warning`, warning).then((response) => {
            commit('resetNewWarning')
            return response
        }).catch(exception => {
            helpers.handleMildAxiosError(exception)
        })
    },
    deleteWarning({commit}, warningId) {


        axios.delete(process.env.VUE_APP_API_URL + `/warning/${warningId}`)
            .then(() => {
                helpers.handleSuccessMessage("Der Hinweis wurde gelöscht.")
                commit('clearWarnings')
                window.location = "/Hinweise"
            })
            .catch(() => {
                helpers.handleWarningMessage("Der Hinweis konnte nicht gelöscht werden.")
            })
    },
    saveWarningPositions({commit, dispatch}, warnings) {
        axios.post(process.env.VUE_APP_API_URL + '/warnings/position', warnings)
            .then(() => {
                commit('clearWarnings')
                dispatch('getWarnings')
                helpers.handleSuccessMessage("Die Reihenfolge wurde gespeichert!")
            })
            .catch(() => helpers.handleWarningMessage("Die Reihenfolge konnte nicht gespeichert werden!"))
    },
}
